import { Card, Typography } from "antd";
import {
  AppstoreOutlined,
  AuditOutlined,
  BarChartOutlined,
  CarOutlined,
  CheckSquareOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeploymentUnitOutlined,
  ProjectOutlined,
  ReadOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

export interface NavCard {
  key: string;
  label: string;
  path: string;
  description?: string;
  icon?: string;
}

const ICONS: Record<string, typeof AppstoreOutlined> = {
  dashboard: DashboardOutlined,
  approvals: CheckSquareOutlined,
  operations: DeploymentUnitOutlined,
  projects: ProjectOutlined,
  stock: DatabaseOutlined,
  procurement: ShoppingCartOutlined,
  masters: AppstoreOutlined,
  attendance: TeamOutlined,
  services: CarOutlined,
  reports: BarChartOutlined,
  admin: SettingOutlined,
  audit: AuditOutlined,
  tutorials: ReadOutlined,
};

/** The card grid that replaced the sidebar — used by the landing page and every module hub. */
export function NavCards({ cards }: { cards: NavCard[] }) {
  return (
    <div className="glut-card-grid">
      {cards.map((card) => {
        const Icon = card.icon ? ICONS[card.icon] : undefined;
        return (
          // aria-label pins the accessible name to the label so the description doesn't join it.
          <Link key={card.key} to={card.path} className="glut-card-link" aria-label={card.label} data-tour={`nav-card-${card.key}`}>
            <Card hoverable className="glut-nav-card">
              <div className="glut-nav-card-title">
                {Icon && <Icon className="glut-nav-card-icon" />}
                <Typography.Text strong>{card.label}</Typography.Text>
              </div>
              {card.description && (
                <Typography.Text type="secondary" className="glut-nav-card-desc">
                  {card.description}
                </Typography.Text>
              )}
            </Card>
          </Link>
        );
      })}
    </div>
  );
}
